export default "__VITE_ASSET__0ea62452__"